import { ExternalLink, Printer } from "lucide-react";
import { useT } from "@/i18n";

export const AffiliateBanner = ({ url, testId = "affiliate-banner" }) => {
  const t = useT();
  return (
    <a
      href={url || "https://kadbisnes.my"}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testId}
      className="group block border border-amber-300 bg-amber-100 transition-colors duration-200 hover:bg-amber-200"
    >
      <div className="mx-auto flex max-w-7xl flex-col items-start gap-2 px-4 py-3 sm:flex-row sm:items-center sm:justify-between sm:px-8">
        <p className="flex items-start gap-2.5 text-sm font-medium text-amber-950">
          <Printer className="mt-0.5 h-4 w-4 shrink-0" />
          <span>
            {t("banner.text")}{" "}
            <strong className="font-bold underline decoration-amber-500 decoration-2">KadBisnes.my</strong>!
          </span>
        </p>
        <span className="inline-flex shrink-0 items-center gap-1.5 rounded-md bg-amber-950 px-3 py-1.5 text-xs font-semibold uppercase tracking-wider text-amber-50">
          {t("banner.cta")} <ExternalLink className="h-3.5 w-3.5" />
        </span>
      </div>
    </a>
  );
};
